import { combineReducers } from "redux";
import eventPage from "./eventPageReducer";
import searchPage from "./searchPageReducer";
import { localizeReducer } from "react-localize-redux";

export default () => combineReducers({
    localize: localizeReducer,
    eventPage,
    searchPage
});